import { useApiClient } from '../client'
import qs from 'qs'

export const GET_CONFIG_ENDPOINT = '/config'

import type { ConfigResponse } from '@/api/types/config'

export function getConfig (country) {
  const apiClient = useApiClient()

  return apiClient.get<ConfigResponse>({
    url: GET_CONFIG_ENDPOINT,
    params: {
      country,
    },
    paramsSerializer: qs.stringify,
  })
}
